import { useState, useEffect } from 'react';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { Menu, MenuItem, Checkbox, ListItemText } from '@mui/material';
import Pill from '@ingka/pill';
import Badge from '@ingka/badge';
import chevronDown from '@ingka/ssr-icon/paths/chevron-down';

export const ISEPFilter = () => {
  const apiRef = useGridApiContext();
  const [isepAnchorEl, setIsepAnchorEl] = useState<null | HTMLElement>(null);
  const [isepFilter, setIsepFilter] = useState<boolean[]>([true, false]);

  const handleIsepClick = (event: React.MouseEvent<HTMLElement>) => {
    setIsepAnchorEl(event.currentTarget);
  };

  const handleIsepClose = () => {
    setIsepAnchorEl(null);
  };

  const toggleIsepValue = (value: boolean) => {
    setIsepFilter((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const toggleSelectAll = () => {
    setIsepFilter((prev) => (prev.length === 2 ? [] : [true, false]));
  };

  const isFiltered = isepFilter.length > 0 && isepFilter.length !== 2;
  const activeFilterCount = isFiltered ? isepFilter.length : 0;

  useEffect(() => {
    if (!isFiltered) {
      apiRef.current.deleteFilterItem({
        field: 'isep',
        operator: 'is',
        id: 'isep-filter',
      });
    } else {
      apiRef.current.upsertFilterItem({
        field: 'isep',
        operator: 'is',
        value: isepFilter[0],
        id: 'isep-filter',
      });
    }
  }, [isFiltered, isepFilter, apiRef]);

  return (
    <>
      <Pill
        onClick={handleIsepClick}
        size="small"
        trailingIcon={chevronDown}
        selected={isFiltered}
        label={
          <span
            style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
          >
            ISEP
            {activeFilterCount > 0 && (
              <Badge
                colour="black"
                label={String(activeFilterCount)}
                size="small"
              />
            )}
          </span>
        }
      />

      <Menu
        anchorEl={isepAnchorEl}
        open={!!isepAnchorEl}
        onClose={handleIsepClose}
        disableScrollLock
        disablePortal
        PaperProps={{ style: { position: 'absolute' } }}
      >
        <MenuItem
          onClick={() => {
            toggleSelectAll();
            handleIsepClose();
          }}
        >
          <Checkbox checked={isepFilter.length === 2} />
          <ListItemText primary="Select all" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            toggleIsepValue(true);
            handleIsepClose();
          }}
        >
          <Checkbox checked={isepFilter.includes(true)} />
          <ListItemText primary="Yes" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            toggleIsepValue(false);
            handleIsepClose();
          }}
        >
          <Checkbox checked={isepFilter.includes(false)} />
          <ListItemText primary="No" />
        </MenuItem>
      </Menu>
    </>
  );
};
